import React from "react";
import {Alert, Snackbar} from "@mui/material";

const TopNotification = (props) => {
    const {severity, message, open, vertical = "top"} = props;
    return (
        <Snackbar id={"top-notification"} sx={{"& svg":{fill: '#ffffff'}}} anchorOrigin={{vertical: vertical, horizontal: 'center'}} open={open}>
            <Alert severity={["error", "info", "success", "warning"].includes(severity) ? severity : "success"} variant="filled">
                {message}
            </Alert>
        </Snackbar>
    );
};

export default TopNotification;